import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-gray-50 py-16 md:py-24" data-id="element-15" data-mp="pio8yn0kl492">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-16" data-mp="avcwmiwkdg7w">
        <header className="mx-auto max-w-4xl text-center" data-id="element-17" data-mp="autgn7qh51wi">
          <h2 className="inline-flex flex-wrap items-center justify-center gap-3 text-3xl font-extrabold leading-tight tracking-tight text-gray-900 md:text-5xl" data-id="element-18" data-mp="ftej7dt77xo4">
            <GiftIcon className="h-8 w-8 text-blue-600 md:h-10 md:w-10" aria-hidden="true" data-id="element-19" data-mp="5w0bc2lcch7f" />
            Además recibes 5 Bonos Profesionales
          </h2>
        </header>

        <ul className="mx-auto mt-12 max-w-3xl divide-y divide-gray-200 overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-200" data-id="element-20" data-mp="3o3fzk3ssx9mh">
          {bonuses.map((bonus, index) => <li key={bonus.tag} className="flex flex-col gap-4 px-5 py-6 sm:flex-row sm:items-start sm:gap-5 md:px-7" data-id="element-21" data-mp="1mars1i94k00w" data-mpi={index}>
              <span className="text-2xl font-extrabold tracking-tight text-blue-200" data-id="element-22" data-mp="1r78rh8lry0ta">
                0{index + 1}
              </span>
              <div className="min-w-0 flex-1" data-id="element-23" data-mp="3dfv6j27jnjbc">
                <p className="text-xs font-bold uppercase tracking-wider text-blue-600" data-id="element-24" data-mp="3df3a5p64hhk0">
                  {bonus.tag}
                </p>
                <h3 className="mt-1 text-lg font-extrabold tracking-tight text-gray-900" data-id="element-25" data-mp="3n5eqkb6ztj7s">
                  {bonus.title}
                </h3>
                <div className="mt-2 space-y-2 text-gray-600" data-id="element-26" data-mp="2zgdfeg6rztyt">
                  {bonus.paragraphs.map(paragraph => <p key={paragraph} data-id="element-27" data-mp="2uibxvzp002pg">{paragraph}</p>)}
                </div>
                {bonus.items && <ul className="mt-3 space-y-1.5 text-sm text-gray-900" data-id="element-28" data-mp="33hfemx0p060s">
                    {bonus.items.map(item => <li key={item} data-id="element-29" data-mp="np89wdpqt5ho">{item}</li>)}
                  </ul>}
              </div>
              <div className="flex shrink-0 items-center gap-3 sm:flex-col sm:items-end sm:gap-1" data-id="element-30" data-mp="iqew0k6jncgz">
                <span className="text-sm text-gray-400 line-through" data-id="element-31" data-mp="3ciephdjl2d3u">{bonus.value}</span>
                <span className="inline-block whitespace-nowrap rounded-md bg-emerald-50 px-2.5 py-1 text-xs font-bold uppercase tracking-wide text-emerald-700" data-id="element-32" data-mp="3hgolfqd4thqi">
                  Incluido gratis
                </span>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}